import { getOwaCanaryCookie } from 'owa-service/lib/canary';
import { trace } from 'owa-trace';
import { HttpStatusCode, HttpReadyState } from 'owa-http-status-codes';

export default function sendOwsAttachmentRequest(
    url: string,
    requestObject: any,
    owaActionRequestHeader: string,
    contentBlob?: Blob,
    onProgressHandler?: (e: ProgressEvent) => void,
    additionalHeaders?: { [headerName: string]: string }
): Promise<any> {
    return new Promise((resolve, reject) => {
        const request: XMLHttpRequest = new XMLHttpRequest();
        request.onreadystatechange = function() {
            if (request.readyState === HttpReadyState.Done) {
                if (request.status === HttpStatusCode.OK) {
                    let response;
                    try {
                        response = JSON.parse(request.responseText);
                    } catch (error) {
                        trace.error(
                            'Attachment: Deserialize response failed with error: ' + error.Message
                        );
                        trace.error(
                            'Attachment: Deserialize response Failure Stack Trace: ' + error.stack
                        );
                        reject(error);
                    }

                    resolve(response);
                } else {
                    reject(
                        new Error(
                            'Request failed with status ' +
                                request.status +
                                '. Message: ' +
                                request.responseText
                        )
                    );
                }
            }
        };

        request.ontimeout = function() {
            reject(new Error('Request timed out'));
        };

        if (onProgressHandler) {
            request.upload.onprogress = onProgressHandler;
        }

        request.open('POST', url, true);
        request.setRequestHeader('X-OWA-Action', owaActionRequestHeader);
        request.setRequestHeader('X-OWA-CANARY', getOwaCanaryCookie());

        if (additionalHeaders) {
            Object.keys(additionalHeaders).forEach(headerName => {
                request.setRequestHeader(headerName, additionalHeaders[headerName]);
            });
        }

        const serializedRequest: string = JSON.stringify(requestObject);
        if (contentBlob) {
            request.setRequestHeader('X-OWA-UrlPostData', encodeURIComponent(serializedRequest));
            request.send(contentBlob);
        } else {
            request.send(serializedRequest);
        }
    });
}
